// extracted by mini-css-extract-plugin
export default {"cont":"APILogs_cont__-sFgd","title":"APILogs_title__hR1TV"};